/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SelectEscapeState = {
  itemId: string
  itemType: GQL_Searchable
  isOpen: boolean
  source: string
  itemAddedTo?: string[]
  itemRemovedFrom?: string[]
}

const initialState = {
  isOpen: false,
  itemId: null,
  itemType: null,
  source: null,
  // ids of which bucket lists current item was added/removed to/from, so components can
  // select this state and perform callbacks for optimistic state updates etc.
  itemAddedTo: [],
  itemRemovedFrom: [],
} as SelectEscapeState

const selectEscapeSlice = createSlice({
  name: 'selectEscape',
  initialState,
  reducers: {
    openSelectEscape(
      state,
      action: PayloadAction<{
        itemId: string
        itemType: GQL_Searchable
        source: string
      }>
    ) {
      state.isOpen = true
      state.itemId = action.payload.itemId
      state.itemType = action.payload.itemType
      state.source = action.payload.source
    },
    closeSelectEscape(state) {
      state.isOpen = false
      state.itemId = null
      state.itemType = null
      state.source = null
    },
    selectEscapeItemAddedTo(
      state,
      action: PayloadAction<{ bucketListId: string }>
    ) {
      state.itemAddedTo.push(action.payload.bucketListId)
    },
    selectEscapeItemRemovedFrom(
      state,
      action: PayloadAction<{ bucketListId: string }>
    ) {
      state.itemRemovedFrom.push(action.payload.bucketListId)
    },
    selectEscapeClearItemAddedTo(state) {
      state.itemAddedTo = []
    },
    selectEscapeClearItemRemovedFrom(state) {
      state.itemRemovedFrom = []
    },
  },
})

export const {
  openSelectEscape,
  closeSelectEscape,
  selectEscapeItemAddedTo,
  selectEscapeItemRemovedFrom,
  selectEscapeClearItemAddedTo,
  selectEscapeClearItemRemovedFrom,
} = selectEscapeSlice.actions

export default selectEscapeSlice.reducer
